import { render, staticRenderFns } from "./ContactPerson.vue?vue&type=template&id=633dd30d&scoped=true"
import script from "./ContactPerson.vue?vue&type=script&lang=js"
export * from "./ContactPerson.vue?vue&type=script&lang=js"
import style0 from "./ContactPerson.vue?vue&type=style&index=0&id=633dd30d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633dd30d",
  null
  
)

export default component.exports